import Autosuggest from "react-autosuggest";
import horsey from "fuzzysearch";
import React from "react";
import { quitaAcentos } from "../utils/helpers";
import SVGInline from "react-svg-inline";
import { Link } from "react-router-dom";
import { Route, Redirect } from "react-router";

// Imagine you have a list of grupos that you'd like to autosuggest.
const theme = {
	container: {
		position: "relative"
	},
	input: {
		width: "100%",
		height: 52,
		padding: "0px 00px",
		fontFamily: "Roboto, sans-serif",
		fontWeight: 300,
		fontSize: 16,
		border: 0,
		borderTopLeftRadius: 0,
		borderTopRightRadius: 0,
		borderBottomLeftRadius: 0,
		borderBottomRightRadius: 0,
		boxSizing: "border-box",
		margin: 0,
		marginLeft: "50px",
		padding: 0,
		backgroundColor: "transparent"
	},
	inputFocused: {
		outline: "none",
		boxSizing: "border-box"
	},
	inputOpen: {
		borderBottomLeftRadius: 0,
		borderBottomRightRadius: 0,
		boxSizing: "border-box"
	},
	suggestionsContainer: {
		display: "none",
		boxSizing: "border-box"
	},
	suggestionsContainerOpen: {
		display: "block",
		position: "absolute",
		top: 53,
		width: "100%",
		border: 0,
		backgroundColor: "white",
		fontFamily: "Roboto, sans-serif",
		fontWeight: 300,
		fontSize: 16,
		borderBottomLeftRadius: 0,
		borderBottomRightRadius: 0,
		zIndex: 2,
		boxSizing: "border-box"
	},
	suggestionsList: {
		marginLeft: "0px",
		padding: 0,
		listStyleType: "none",
		boxSizing: "border-box"
	},
	suggestion: {
		marginLeft: "50px",
		cursor: "pointer",
		padding: "10px 0px",
		boxSizing: "border-box",
		marginBottom: 0
	},
	suggestionHighlighted: {
		backgroundColor: "transparent",
		fontWeight: 600,
		boxSizing: "border-box"
	}
};

const grupos = [
	{
		name: "Las del convento de Santa María La Yerbabuena",
		cat: "chi",
		ide: "chi_1"
	},
	{ name: "Los sirenitas", cat: "chi", ide: "chi_10" },
	{ name: "Los brujos titis", cat: "chi", ide: "chi_11" },
	{ name: "Las pinchapelotas", cat: "chi", ide: "chi_12" },
	{ name: "Los quitapupas", cat: "chi", ide: "chi_13" },
	{ name: "Campeones por cojones", cat: "chi", ide: "chi_14" },
	{ name: "¡Ojú cómo está el patio!", cat: "chi", ide: "chi_15" },
	{ name: "Los que van a su bola", cat: "chi", ide: "chi_16" },
	{ name: "En la ciudad de Cádiz, siendo las....", cat: "chi", ide: "chi_17" },
	{ name: "Los que vienen de vuelta", cat: "chi", ide: "chi_18" },
	{
		name: "Dónde meto el elefante en el piso de estudiantes",
		cat: "chi",
		ide: "chi_19"
	},
	{
		name: "Los que se meten en todas las conversaciones",
		cat: "chi",
		ide: "chi_2"
	},
	{ name: "No tenemos el congo pa farolillos", cat: "chi", ide: "chi_20" },
	{ name: "No te quemes todavía", cat: "chi", ide: "chi_21" },
	{ name: "Los maniáticos", cat: "chi", ide: "chi_22" },
	{ name: "Cai de miarma (7,20)", cat: "chi", ide: "chi_23" },
	{ name: "Regreso del futuro", cat: "chi", ide: "chi_24" },
	{ name: "Este año nos veréis en el altar", cat: "chi", ide: "chi_25" },
	{ name: "Felices a las cuatro", cat: "chi", ide: "chi_26" },
	{ name: "Cari, tenemos toda la eternidad", cat: "chi", ide: "chi_27" },
	{ name: "¡Cómo se te caiga, cobras!", cat: "chi", ide: "chi_28" },
	{ name: "AAVV Gruñón Arenillas", cat: "chi", ide: "chi_29" },
	{ name: "Los que se mueren por su Barbi", cat: "chi", ide: "chi_3" },
	{ name: "Los que miran por encima del hombro", cat: "chi", ide: "chi_30" },
	{ name: "Los de San Antonio", cat: "chi", ide: "chi_31" },
	{ name: "Los que la llevan a hombros", cat: "chi", ide: "chi_32" },
	{ name: "Los jubilados del Soto del Relax", cat: "chi", ide: "chi_33" },
	{ name: "Harto palo", cat: "chi", ide: "chi_34" },
	{ name: "Las que embrujaban de verdad", cat: "chi", ide: "chi_35" },
	{
		name:
			"Lo mio es mio, lo tuyo es tuyo, y lo mio es lo mejón (Los envidiosos)",
		ide: "chi_36"
	},
	{ name: "Sal Fermín", cat: "chi", ide: "chi_37" },
	{ name: "Este año ya nos despedimos", cat: "chi", ide: "chi_38" },
	{ name: "Los crazy de los 40", cat: "chi", ide: "chi_39" },
	{ name: "Los campeones", cat: "chi", ide: "chi_4" },
	{ name: "La familia Verdugo", cat: "chi", ide: "chi_40" },
	{ name: "Por si las moscas", cat: "chi", ide: "chi_41" },
	{ name: "Los que pasan página", cat: "chi", ide: "chi_42" },
	{ name: "Los Novelty's", cat: "chi", ide: "chi_43" },
	{ name: "Lo que nos faltaba", cat: "chi", ide: "chi_44" },
	{ name: "Los sensiblones", cat: "chi", ide: "chi_45" },
	{
		name: "La generación del flequillo palante no levantamos cabeza",
		cat: "chi",
		ide: "chi_46"
	},
	{ name: "El circo de la sombra", cat: "chi", ide: "chi_47" },
	{ name: "Aquí hay un chi_vato", cat: "chi", ide: "chi_48" },
	{ name: "Una corrida en tu cara", cat: "chi", ide: "chi_49" },
	{ name: "Son Frescas de la Bahía", cat: "chi", ide: "chi_5" },
	{
		name: "Gracias a mi gesta sabéis que la tenéis redonda y no recta",
		cat: "chi",
		ide: "chi_50"
	},
	{ name: "Ahora bajo... que me estoy cambiando", cat: "chi", ide: "chi_51" },
	{ name: "Los no aptos", cat: "chi", ide: "chi_52" },
	{ name: "Grupo de Guasa", cat: "chi", ide: "chi_6" },
	{ name: "Érase Una Vez... la chi_rigota", cat: "chi", ide: "chi_7" },
	{ name: "¡Qué Caló!", cat: "chi", ide: "chi_8" },
	{ name: "Con las Bombas que tiran", cat: "chi", ide: "chi_9" },
	{ name: "Los mafiosos", cat: "com", ide: "com_1" },
	{ name: "Dios salve a la reina", cat: "com", ide: "com_10" },
	{ name: "El Constructor", cat: "com", ide: "com_11" },
	{ name: "Tic-tac, tic-tac", cat: "com", ide: "com_12" },
	{ name: "Los ángeles de la guarda", cat: "com", ide: "com_13" },
	{ name: "Las noches de Cádiz", cat: "com", ide: "com_14" },
	{ name: "La oportunidad", cat: "com", ide: "com_15" },
	{ name: "Pueblo Llano", cat: "com", ide: "com_16" },
	{ name: "Las irrepetibles", cat: "com", ide: "com_17" },
	{ name: "Los hombres del rey", cat: "com", ide: "com_18" },
	{ name: "Los Cazagigantes", cat: "com", ide: "com_19" },
	{ name: "La cara oculta de la luna", cat: "com", ide: "com_2" },
	{ name: "La Gloria", cat: "com", ide: "com_20" },
	{ name: "La cumbre", cat: "com", ide: "com_21" },
	{ name: "Juan sin miedo", cat: "com", ide: "com_22" },
	{ name: "El rincón del duende", cat: "com", ide: "com_23" },
	{ name: "Los viva la vida", cat: "com", ide: "com_24" },
	{ name: "Los guiritanos", cat: "com", ide: "com_25" },
	{ name: "La justiciera", cat: "com", ide: "com_26" },
	{ name: "El ingeniero", cat: "com", ide: "com_27" },
	{ name: "La playa", cat: "com", ide: "com_28" },
	{ name: "Los incontrolables", cat: "com", ide: "com_29" },
	{ name: "Musicalandia", cat: "com", ide: "com_3" },
	{ name: "Los campaneros", cat: "com", ide: "com_30" },
	{ name: "Los prisioneros", cat: "com", ide: "com_31" },
	{ name: "La otra mejilla", cat: "com", ide: "com_32" },
	{ name: "Obdc. El joven obispo", cat: "com", ide: "com_33" },
	{ name: "La octava maravilla", cat: "com", ide: "com_34" },
	{ name: "Los zincalé", cat: "com", ide: "com_35" },
	{ name: "Este gitano está majara", cat: "com", ide: "com_36" },
	{ name: "El vendedor", cat: "com", ide: "com_37" },
	{ name: "Cómicos", cat: "com", ide: "com_38" },
	{ name: "El almacén", cat: "com", ide: "com_39" },
	{ name: "La niña del viento", cat: "com", ide: "com_4" },
	{ name: "El incom_prendido", cat: "com", ide: "com_40" },
	{ name: "Los destronados", cat: "com", ide: "com_41" },
	{ name: "Se buscan valientes", cat: "com", ide: "com_42" },
	{ name: "Los noctámbulos", cat: "com", ide: "com_43" },
	{ name: "Hermanos", cat: "com", ide: "com_44" },
	{ name: "La errante", cat: "com", ide: "com_45" },
	{ name: "El perro andalú", cat: "com", ide: "com_46" },
	{ name: "Las guerrilleras", cat: "com", ide: "com_47" },
	{ name: "El genio", cat: "com", ide: "com_48" },
	{
		name: "Ni los malos son tan malos, ni los buenos...",
		cat: "com",
		ide: "com_5"
	},
	{ name: "El gurú", cat: "com", ide: "com_50" },
	{ name: "Los soñadores", cat: "com", ide: "com_51" },
	{ name: "Vientos", cat: "com", ide: "com_52" },
	{ name: "Algunos hombres buenos", cat: "com", ide: "com_53" },
	{ name: "La sonrisa de Dios", cat: "com", ide: "com_54" },
	{ name: "La canción perdida", cat: "com", ide: "com_55" },
	{ name: "El catedrático", cat: "com", ide: "com_56" },
	{ name: "La botellona", cat: "com", ide: "com_57" },
	{ name: "La travesía", cat: "com", ide: "com_58" },
	{ name: "Los vivelavida", cat: "com", ide: "com_59" },
	{ name: "Los desvelaos", cat: "com", ide: "com_6" },
	{ name: "Las noches de Carnaval", cat: "com", ide: "com_60" },
	{ name: "La inoportuna", cat: "com", ide: "com_61" },
	{ name: "La esclavitud", cat: "com", ide: "com_62" },
	{ name: "La perla dorada", cat: "com", ide: "com_63" },
	{ name: "En blanco y negro", cat: "com", ide: "com_64" },
	{ name: "Los encantadores", cat: "com", ide: "com_7" },
	{ name: "El oro negro", cat: "com", ide: "com_8" },
	{ name: "La Pasarela", cat: "com", ide: "com_9" },
	{ name: "Los chi_menea", cat: "cor", ide: "cor_1" },
	{ name: "De mil colores", cat: "cor", ide: "cor_10" },
	{ name: "Los nostálgicos de la transición", cat: "cor", ide: "cor_11" },
	{ name: "Vive, sueña, canta", cat: "cor", ide: "cor_12" },
	{ name: "Los queus de Cádiz", cat: "cor", ide: "cor_13" },
	{ name: "Y sin embargo, te quiero", cat: "cor", ide: "cor_14" },
	{ name: "Tiempos modernos", cat: "cor", ide: "cor_15" },
	{ name: "Estamos encantados", cat: "cor", ide: "cor_16" },
	{ name: "El conquistador", cat: "cor", ide: "cor_17" },
	{ name: "La comuna", cat: "cor", ide: "cor_2" },
	{ name: "La Mari", cat: "cor", ide: "cor_3" },
	{ name: "La centuria", cat: "cor", ide: "cor_4" },
	{ name: "Rockola", cat: "cor", ide: "cor_5" },
	{ name: "Don Taratachín", cat: "cor", ide: "cor_6" },
	{ name: "Las mil y una historias", cat: "cor", ide: "cor_7" },
	{ name: "La Esquinita", cat: "cor", ide: "cor_8" },
	{ name: "El diablo se viste de cor_o", cat: "cor", ide: "cor_9" },
	{ name: "Mission impossible: los astromantas", cat: "cua", ide: "cua_1" },
	{
		name: "Lo mismo nos vemos en Elcano que en clase de piano",
		cat: "cua",
		ide: "cua_2"
	},
	{
		name: "El equipo 'a' minúscula (Comando Caleti)",
		cat: "cua",
		ide: "cua_3"
	},
	{ name: "Los de la gran puñeta", cat: "cua", ide: "cua_4" },
	{ name: "El trío", cat: "cua", ide: "cua_5" },
	{ name: "Madre mía", cat: "cua", ide: "cua_6" }
];

// Teach Autosuggest how to calculate suggestions for any given input value.

const getSuggestions = value => {
	const inputValue = value.trim().toLowerCase();
	const inputLength = inputValue.length;

	return inputLength === 0
		? []
		: grupos.filter(agr =>
				horsey(inputValue, quitaAcentos(agr.name.toLowerCase()))
			);
};

class SearchGen extends React.Component {
	constructor(props) {
		super(props);
		// Autosuggest is a controlled component.
		// This means that you need to provide an input value
		// and an onChange handler that updates this value (see below).
		// Suggestions also need to be provided to the Autosuggest,
		// and they are initially empty because the Autosuggest is closed.
		this.state = {
			value: "",
			suggestions: [],
			ide: ""
		};
		// BINDINGS
		this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
	}

	onSuggestionSelected(e) {
		if (this.state.ide) {
			this.props.history.push(`/agrupaciones/${this.state.ide}`);
		} else {
			this.props.history.push(`/agrupaciones/${e.target.dataset.ide}`);
		}
	}

	onChange = (event, { newValue }) => {
		// otherwise, let the change go through
		this.setState({ value: newValue });
	};

	// Autosuggest will call this function every time you need to update suggestions.
	// You already implemented this logic above, so just use it.
	onSuggestionsFetchRequested = ({ value }) => {
		this.setState({
			suggestions: getSuggestions(value)
		});
	};

	// Autosuggest will call this function every time you need to clear suggestions.
	onSuggestionsClearRequested = () => {
		this.setState({
			suggestions: []
		});
	};

	render() {
		// ---------------------------------------------

		// CREA EL ARRAY DE ARRIBA

		// ---------------------------------------------

		// When suggestion is clicked, Autosuggest needs to populate the input
		// based on the clicked suggestion. Teach Autosuggest how to calculate the
		// input value for every given suggestion.
		const getSuggestionValue = suggestion => {
			this.setState({ ide: suggestion.ide });
			return suggestion.name;
		};
		// Use your imagination to render suggestions.
		const renderSuggestion = suggestion => (
			<div className={`suggestion ${suggestion.cat}`} data-ide={suggestion.ide}>
				{suggestion.name}
			</div>
		);

		const { value, suggestions } = this.state;
		// Autosuggest will pass through all these props to the input.
		const inputProps = {
			placeholder: "Buscador de agrupaciones",
			value,
			onChange: this.onChange
		};

		// Render
		return (
			<div style={{ position: "relative" }}>
				<Autosuggest
					suggestions={suggestions}
					onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
					onSuggestionsClearRequested={this.onSuggestionsClearRequested}
					onSuggestionSelected={this.onSuggestionSelected}
					getSuggestionValue={getSuggestionValue}
					renderSuggestion={renderSuggestion}
					inputProps={inputProps}
					theme={theme}
				/>
				<SVGInline
					style={{
						width: "28px",
						height: "28px",
						position: "absolute",
						top: "13px",
						left: "3px",
						zIndex: 100
					}}
					svg={
						"<svg xmlns='http://www.w3.org/2000/svg' class='search-icon' width='24px' height='24px' viewBox='0 0 24 24'> <path fill='#292929' d='M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z'></path> </svg>"
					}
				/>
				<div />
			</div>
		);
	}
}

export default SearchGen;



// WEBPACK FOOTER //
// ./src/components/SearchGen.js